import { Body, Icon, IconType } from '@assembly-js/design-system';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

export const MenuOption = React.forwardRef<
  HTMLLIElement,
  {
    icon: IconType;
    text: string;
    onClick: () => void;
    isDestructiveAction?: boolean;
    disabled?: boolean;
    className?: string;
    'data-testid'?: string;
  }
>(
  (
    {
      icon,
      text,
      onClick,
      isDestructiveAction,
      disabled,
      className,
      'data-testid': dataTestId,
    },
    ref,
  ) => (
    <MenuItem
      ref={ref}
      classes={{ root: clsx('px-3 py-0.5', className) }}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
    >
      <ListItemIcon classes={{ root: 'mr-3' }}>
        <Icon
          icon={icon}
          className={clsx(
            'w-[13px] h-[13px]',
            isDestructiveAction ? 'text-error-primary' : 'text-black-heading',
          )}
        />
      </ListItemIcon>
      <ListItemText>
        <Body
          className={clsx(
            isDestructiveAction ? 'text-error-primary' : 'text-black-heading',
          )}
        >
          {text}
        </Body>
      </ListItemText>
    </MenuItem>
  ),
);
MenuOption.displayName = 'MenuOption';
